import {
  SET_QR_URL,
  SET_UTM_SOURCE,
  SET_UTM_MEDIUM,
  SET_UTM_CAMPAIGN_NAME,
  SET_QR_SEND_EMAIL,
  SET_QR_NOTIFICATION_EMAIL,
  SET_CUSTOM_UTMS,
  CLEAR_QR_FIELDS,
  SET_IS_QR,
  SET_QR_DIALOG,
  CLOSE_QR_DIALOG,
} from '../actions/action-types';

export const setIsQR = (isQR: boolean) => ({
  type: SET_IS_QR,
  payload: isQR,
});

export const setQrUrl = (url: string) => ({
  type: SET_QR_URL,
  payload: url,
});

export const setUtmSource = (utmSource: string) => ({
  type: SET_UTM_SOURCE,
  payload: utmSource,
});

export const setUtmMedium = (utmMedium: string) => ({
  type: SET_UTM_MEDIUM,
  payload: utmMedium,
});

export const setUtmCampaignName = (utmCampaignName: string) => ({
  type: SET_UTM_CAMPAIGN_NAME,
  payload: utmCampaignName,
});

export const setQrSendEmail = (sendEmail: boolean) => ({
  type: SET_QR_SEND_EMAIL,
  payload: sendEmail,
});

export const setQrNotificationEmail = (notificationEmail: string) => ({
  type: SET_QR_NOTIFICATION_EMAIL,
  payload: notificationEmail,
});

export const setCustomUtms = (customUtms: Record<string, any>) => ({
  type: SET_CUSTOM_UTMS,
  payload: customUtms,
});

export const clearQrFields = () => ({
  type: CLEAR_QR_FIELDS,
});

export const setQrDialog = (open: boolean, model: string = '') => ({
  type: SET_QR_DIALOG,
  payload: { open, model },
});

export const closeQrDialog = () => ({
  type: CLOSE_QR_DIALOG,
});
